import { render, staticRenderFns } from "./Collected.vue?vue&type=template&id=2b0cb522&scoped=true"
import script from "./Collected.vue?vue&type=script&lang=js"
export * from "./Collected.vue?vue&type=script&lang=js"
import style0 from "./Collected.vue?vue&type=style&index=0&id=2b0cb522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cb522",
  null
  
)

export default component.exports